module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "barHolder"
  }, [_c('div', {
    staticClass: "barFill",
    class: {
      'paused': _vm.pause
    },
    style: ({
      'width': _vm.currentBarWidth
    })
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-f20a5118", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f20a5118"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/notifications/floatingNotifications/timedBar.vue
// module id = 1432
// module chunks = 0